import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { SparklesIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 bg-navy-900 relative overflow-hidden" data-id="element-234">
      {/* Decorative background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-500/5 rounded-full blur-3xl pointer-events-none" data-id="element-235"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-236">
        <FadeIn data-id="element-237">
          <div className="text-center mb-12" data-id="element-238">
            <h2 className="text-3xl md:text-4xl font-serif mb-6" data-id="element-239">
              La solución no está en qué químico añadir a tu cuerpo...
            </h2>
            <p className="text-xl text-gold-400 font-serif italic" data-id="element-240">
              Sino en cómo activar el "Reset Circadiano".
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-241">
          <div className="border border-gold-500/30 bg-navy-800/80 backdrop-blur-sm p-8 md:p-12 rounded-sm box-glow relative" data-id="element-242">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-navy-900 border border-gold-500/30 px-4 py-2 rounded-full flex items-center gap-2" data-id="element-243">
              <SparklesIcon className="w-4 h-4 text-gold-400" data-id="element-244" />
              <span className="text-sm font-medium tracking-wider text-gold-400 uppercase" data-id="element-245">
                El Mecanismo Único
              </span>
            </div>

            <p className="text-body-lg text-cream-muted leading-relaxed text-center" data-id="element-246">
              Este método utiliza la ciencia de la termorregulación y la
              oxigenación para forzar a tu sistema nervioso a pasar del estado
              de alerta al estado de reparación profunda en menos de 15 minutos.
              <br data-id="element-247" />
              <br data-id="element-248" />
              <strong className="text-cream font-normal" data-id="element-249">
                Es un proceso físico, no mental
              </strong>
              , que engaña a tu biología para que entre en la fase REM de forma
              automática.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}